export const LandingSourceCarousel = ({ data, options }) => {
  return (
    <>
      <div className="LandingSourceCarousel-wrapper">
        <div className="LandingSourceCarousel" {...options}>
          <div className="LandingSourceCarousel-sources-wrapper">
            <div className="LandingSourceCarousel-sources">
              {data
                ?.filter(s => s.logo)
                .map(source => (
                  <div className="LandingSourceCarousel-source" key={source.name}>
                    <img
                      src={source.logo}
                      alt={source.name}
                      height="64"
                      width="64"
                      loading="lazy"
                    />
                    <span>{source.name}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
